import { NgModule } from "@angular/core";
import { ReportModalComponent } from "./report-modal/report-modal.component";
import { ReportListComponent } from "./report-list/report-list.component";
import { AuthGuard } from "../../util/guard/auth.guard";
import { RouterModule } from "@angular/router";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgxDatatableModule } from "@siemens/ngx-datatable";
import { NgSelectModule } from "@ng-select/ng-select";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { ComponentsModule } from "../../util/components/components.module";
import { NgbAlertModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { OfficesResolver } from "../../util/resolver/offices.resolver";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { QuillEditorComponent } from "ngx-quill";
import { ViewModalComponent } from './view-modal/view-modal.component';

const routes = [
  {
    path: "reports",
    component: ReportListComponent,
    canActivate: [AuthGuard],
    resolve: {
      offices: OfficesResolver,
    },
  },
];

@NgModule({
  declarations: [ReportModalComponent, ReportListComponent, ViewModalComponent],
  imports: [
    RouterModule.forChild(routes),
    ContentHeaderModule,
    CoreCommonModule,
    NgxDatatableModule,
    NgSelectModule,
    SweetAlert2Module,
    ComponentsModule,
    NgbNavModule,
    NgbAlertModule,
    CdkTextareaAutosize,
    QuillEditorComponent,
  ],
})
export class ReportsModule {}
